import { ASSIGNED_TYPE } from '@vindr/services/constants/assigned.constant';
import { MESSAGE } from '@vindr/services/constants/message.constant';

export function validateEmptyAssign({
  assignType,
  message,
}: {
  assignType: ASSIGNED_TYPE;
  message: any;
}) {
  const result = {
    [ASSIGNED_TYPE.USER]: MESSAGE.ERROR.EMSG_17004,
    [ASSIGNED_TYPE.GROUP]: MESSAGE.ERROR.EMSG_17003,
  };

  if (result[assignType]) return message.error(result[assignType]);
  throw new Error('Assign type is not valid');
}
